import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Sayfa değiştiğinde scroll'u en üste (0,0) taşı
    window.scrollTo(0, 0);
  }, [pathname]); // Her pathname (url) değiştiğinde tetiklenir

  return null;
};

export default ScrollToTop;